const question6 = {
    'question': 'Jak wygląda pierwsze spotkanie z terapeutą rodzin?',
    'answer': 'Pierwsze spotkanie z terapeutą rodzin jest zwykle spotkaniem zapoznawczym. Terapeuta poznaje rodzinę i jej problemy. Terapeuta zadaje rodzinie pytania na temat ich historii, oczekiwań, potrzeb, oraz celów w terapii. Terapeuta pomaga rodzinie zrozumieć ich wzajemne relacje i identyfikuje problemy, które wymagają rozwiązania.',
}

export default question6;